import { render, staticRenderFns } from "./ChordPlayer.vue?vue&type=template&id=c3327bfe"
import script from "./ChordPlayer.vue?vue&type=script&lang=js"
export * from "./ChordPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports